import { isFunction } from "../data/utils.js";

export class Control {

    constructor(parent, options = {}) {

        const {
            id = null,
            visible = true,
            disabled = false,
            css = null,
            app = null,
        } = options;

        this.parent = null;
        this.app = app;
        this.id = id;
        this.visible = visible;
        this.disabled = disabled;
        this.css = css;

        if (parent) {
            if (isFunction(parent.mountControl)) {
                parent.mountControl(this);
            } else {
                this.parent = parent;
            }
        }

    };

    dispose() {

        if (this.parent) {
            if (isFunction(this.parent.unmountControl)) {
                this.parent.unmountControl(this);
            }
            this.parent = null;
        }

    }

    // --------------------------------------------------------------------------------------------

    getParent() {

        if (this.parent == null)
            throw new Error('[Control] "parent" is required.');
        return this.parent;

    };

    getApp() {

        if (!this) {
            console.log("THIS is missing!");
        }
        if (this.parent)
            return this.parent.getApp();
        if (this.app)
            return this.app;
        return this.getParent().getApp();

    };

    getConfig() { return this.getApp().getConfig(); };

    getI18n() { return this.getApp().getI18n(); };

    getStorage() { return this.getApp().getStorage(); };

    getLogger() { return this.getApp().getLogger(); };

    getRenderer() { return this.getApp().getRenderer(); };

    getServices() { return this.getApp().getServices(); };

    getAuthManager() { return this.getApp().getAuthManager(); };

    getAuthService() { return this.getApp().getAuthService(); };

    getHttpService() { return this.getApp().getHttpService(); };

    getServiceFactory() { return this.getApp().getServiceFactory(); };

    // --------------------------------------------------------------------------------------------

    isVisible() {

        return (typeof this.visible == 'function' ? this.visible.call(this) : this.visible);

    };

    isReadOnly() {

        return (typeof this.readOnly == 'function' ? this.readOnly.call(this) : this.readOnly);

    };

    isDisabled() {

        return (typeof this.disabled == 'function' ? this.disabled.call(this) : this.disabled);

    };

    getId() {

        return (typeof this.id == 'function' ? this.id.call(this) : (this.id || null));

    };

    getCss() {

        return (typeof this.css == 'function' ? this.css.call(this) : (this.css || ''));

    };

    // --------------------------------------------------------------------------------------------

    async prepare(options) {

        await this._prepare(options);

    };

    async _prepare(options) {

        return true;

    };

    async refresh() {

        await this._refresh();

    };

    async _refresh() {

        return true;

    };


    // --------------------------------------------------------------------------------------------

    render(renderer, vm = null) {

        return this._render(renderer, vm);

    };

    _render(r, vm) {

        return r.el('div', null, null, [
            '[Control]'
        ]);

    };

    /**
     * Vynucení překreslení controlu.
     * @param {number} [level] - Hloubka překreslení.
     *     0 = překreslení rodiče (nejbližší Component),
     *     1 = překreslení rodiče rodiče...
     */
    invalidate(level = 0) {

        this.getParent().invalidate(level);

    };

    /**
     * Vynucení překreslení celé aplikace.
     */
    invalidateApp() {

        this.getApp().invalidate();

    }


}
